
        import { injectStyle } from '__style_helper__'
        injectStyle("@layer typography{p{font-weight:100}strong{font-weight:500}}")

        export default {}
        